/**
 * @generated SignedSource<<65e197e490012430fac6e6471feaf9a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type RestrictionCountQualifier = "BILLABLE_MEMBER" | "GUEST" | "MEMBER";
export type RestrictionCountUnit = "BOOKINGS" | "HOURS" | "ROUNDS";
export type RestrictionMemberOverride = "NONE" | "WARN";
export type RestrictionStaffOverride = "FULL" | "NONE" | "WARN";
export type RestrictionTimeUnit = "DAYS" | "HOURS" | "MONTHS" | "WEEKS" | "YEARS";
import { FragmentRefs } from "relay-runtime";
export type useGetBookingRestrictionStatusesFragment$data = {
  readonly __typename: string;
  readonly restrictionStatuses: {
    readonly groupStatuses: {
      readonly statuses: ReadonlyArray<{
        readonly count: number;
        readonly rule: {
          readonly __typename: string;
          readonly bookingCriteria?: {
            readonly maxPlayers: number | null | undefined;
            readonly minPlayers: number | null | undefined;
          } | null | undefined;
          readonly bookingType?: BookingType;
          readonly countLimit?: {
            readonly countLimit: number;
            readonly countUnit: RestrictionCountUnit;
            readonly qualifier: RestrictionCountQualifier;
            readonly showNonViolating: boolean | null | undefined;
            readonly timeLimit: number | null | undefined;
            readonly timeUnit: RestrictionTimeUnit | null | undefined;
          } | null | undefined;
          readonly displayName?: string | null | undefined;
          readonly id: string;
          readonly memberMessage?: string | null | undefined;
          readonly memberOverride?: RestrictionMemberOverride | null | undefined;
          readonly name: string;
          readonly staffOverride?: RestrictionStaffOverride | null | undefined;
        };
        readonly willViolate: boolean;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly roundStatuses: ReadonlyArray<{
      readonly statuses: ReadonlyArray<{
        readonly count: number;
        readonly rule: {
          readonly __typename: string;
          readonly bookingCriteria?: {
            readonly maxPlayers: number | null | undefined;
            readonly minPlayers: number | null | undefined;
          } | null | undefined;
          readonly bookingType?: BookingType;
          readonly countLimit?: {
            readonly countLimit: number;
            readonly countUnit: RestrictionCountUnit;
            readonly qualifier: RestrictionCountQualifier;
            readonly showNonViolating: boolean | null | undefined;
            readonly timeLimit: number | null | undefined;
            readonly timeUnit: RestrictionTimeUnit | null | undefined;
          } | null | undefined;
          readonly displayName?: string | null | undefined;
          readonly id: string;
          readonly memberMessage?: string | null | undefined;
          readonly memberOverride?: RestrictionMemberOverride | null | undefined;
          readonly name: string;
          readonly staffOverride?: RestrictionStaffOverride | null | undefined;
        };
        readonly willViolate: boolean;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetBookingRestrictionStatusesFragment";
};
export type useGetBookingRestrictionStatusesFragment$key = {
  readonly " $data"?: useGetBookingRestrictionStatusesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetBookingRestrictionStatusesFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RestrictionStatus",
    "kind": "LinkedField",
    "name": "statuses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "willViolate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "rule",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberOverride",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "staffOverride",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingRestrictionCountLimit",
                "kind": "LinkedField",
                "name": "countLimit",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countLimit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "qualifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeLimit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showNonViolating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingRuleBookingCriteria",
                "kind": "LinkedField",
                "name": "bookingCriteria",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minPlayers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxPlayers",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "BookingRestrictionRule",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetBookingRestrictionStatusesFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingRuleStatuses",
      "kind": "LinkedField",
      "name": "restrictionStatuses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GroupBookingRuleStatus",
          "kind": "LinkedField",
          "name": "groupStatuses",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundBookingRuleStatus",
          "kind": "LinkedField",
          "name": "roundStatuses",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "561ef190c381bbc48e639be8cb199f4a";

export default node;
